import { render, staticRenderFns } from "./QuestionMetricParagraph.vue?vue&type=template&id=83254f2a&scoped=true&"
import script from "./QuestionMetricParagraph.vue?vue&type=script&lang=js&"
export * from "./QuestionMetricParagraph.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMetricParagraph.vue?vue&type=style&index=0&id=83254f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83254f2a",
  null
  
)

export default component.exports